// utils/formatCurrency.ts
// Locale-aware currency formatting for Novala.
// English (Canada): $52.90 - dollar sign before, period as decimal
// French (Canada/Quebec): 52,90 $ - comma as decimal, space, dollar sign after

export function formatCurrency(amount: number, language: string = "en"): string {
  const isFrench = language.startsWith("fr");

  // Round to 2 decimals
  const rounded = Math.round(amount * 100) / 100;

  if (isFrench) {
    // Quebec/French convention: 52,90 $
    const parts = rounded.toFixed(2).split(".");
    return parts[0] + "," + parts[1] + " $";
  }

  // English default: $52.90
  return "$" + rounded.toFixed(2);
}

// Format currency WITH a suffix (like /mo or /month)
export function formatCurrencyWithSuffix(amount: number, language: string, suffix: { en: string; fr: string }): string {
  const isFrench = language.startsWith("fr");
  return formatCurrency(amount, language) + (isFrench ? suffix.fr : suffix.en);
}
